<script setup lang="ts">
// import { showTurnstile } from '@/ui-plus/dialog/showTurnstile';
import { Button } from '@/components/ui/button'
import { AutoForm } from '@/ui-plus/auto-form'
import { useFormPlus } from "@/ui-plus/form/useFormPlus";
import { toTypedSchema } from "@vee-validate/zod";
import { authGlobalApiClient } from '@api-client/auth_global';
import { useForm } from "vee-validate";
import { z } from "zod";
import { Loader2 } from 'lucide-vue-next';
import { onMounted } from 'vue';

const emit = defineEmits<{
    onError: [errorMessage: string];
    onSuccess: [];
}>();

const schema = z.object({
    newName: z.string()
        .min(1, { message: "Name is required" })
        .max(255, { message: "Name must be at most 255 characters" }),
})

const form = useForm({
    validationSchema: toTypedSchema(schema)
});
const { isLoading, globalError, handleError, withSubmit } = useFormPlus(form);

async function onSubmit(values: z.infer<typeof schema>) {
    await withSubmit(async () => {
        // let turnstile;
        // try {
        //     turnstile = await showTurnstile(import.meta.env.PUBLIC_TURNSTILE_SITE_KEY);
        // } catch (error: unknown) {
        //     const errorMessage = error instanceof Error ? error.message : 'Unknown error occurred';
        //     emit('onError', errorMessage);
        //     return;
        // }
        const { error } = await (await authGlobalApiClient.user['update-name'].$post({
            form: {
                newName: values.newName,
                // turnstile,
            },
        })).json()
        if (error) {
            handleError(error, form);
        } else {
            emit('onSuccess');
        }
    })
}

onMounted(() => {
    setTimeout(() => {
        const nameInput = document.querySelector<HTMLInputElement>('[name="newName"]');
        if (nameInput) {
            nameInput.focus();
        }
    }, 500);
})
</script>

<template>
    <div class="py-10">
        <AutoForm class="space-y-6"
                  :schema="schema"
                  :form="form"
                  @submit="onSubmit"
                  :field-config="{
                    newName: {
                        label: 'Your Name',
                        inputProps: {
                            autocomplete: 'name',
                        },
                    },
                }">
            <div class="text-sm font-medium text-destructive"
                 v-if="globalError">
                {{ globalError }}
            </div>
            <div>
                <Button type="submit"
                        :disabled="isLoading"
                        class="w-full my-6">
                    <Loader2 v-if="isLoading"
                             class="animate-spin" />
                    Save Name
                </Button>
            </div>
        </AutoForm>
    </div>
</template>
